<template>
    <div class="container-outline">
        <div class="register">
            <div class="title-page">Register</div>
            <div class="top-squence">
                <head-register :dataSquence="{ id: 12, title: 'kode akses' }"></head-register>
            </div>
            <div class="content-register">
                <div class="container">
                    <disclosure-statement :disclosureValue="disclosureValue" @updateValue="checkStatement"></disclosure-statement>

                    <div class="button" v-if="currentPage == '/disclosure1'">
                        <router-link to="/investment-experience"><button class="btn-scondary">Sebelumnya</button></router-link>
                        <button class="btn-primer" @click="checkValidasiStatement">
                            <b-spinner small variant="light" v-if="isLoading"></b-spinner>
                            <span v-else>Selanjutnya</span>
                        </button>
                    </div>
                    <div class="button" v-if="currentPage == '/disclosure2'">
                        <router-link to="/register-datalampiran"><button class="btn-scondary">Sebelumnya</button></router-link>
                        <button class="btn-primer" @click="checkValidasiStatement">
                            <b-spinner small variant="light" v-if="isLoading"></b-spinner>
                            <span v-else>Selanjutnya</span>
                        </button>
                    </div>
                    <div class="button" v-if="currentPage == '/disclosure3'">
                        <router-link to="/resiko"><button class="btn-scondary">Sebelumnya</button></router-link>
                        <button class="btn-primer" @click="checkValidasiStatement">
                            <b-spinner small variant="light" v-if="isLoading"></b-spinner>
                            <span v-else>Selanjutnya</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import DisclosureStatement from "@/assets/filedownload/DisclosureStatement.vue";
import HeadRegister from "./component/HeadRegister.vue";
export default {
    components: { DisclosureStatement, HeadRegister },
    data() {
        return {
            currentDate: "",
            currentPage: "",
            isLoading: false,
            openModal: false,
            disclosureValue: "",
            message: "",
            identityAddress: "",
            idCustomer: "",
            form: {
                has_set_trading_simulation: "",
                has_confirm_costumer: "",
                has_investment_experience: "",
                has_set_company_profile: "",
                has_set_investment_experience: "",
                has_set_mandate: "",
                has_set_risk: "",
                has_set_trading_rules: "",
                step: "",
                completeness_verification: "",
                disclosure_customer: false,
                disclosure_risk: false,
                disclosure_mandate: false,
            },
            dataPrint: {
                fullname: "",
                alamat: "",
                telepone: "",
                ktp: "",
                pekerjaan: "",
                tandaTangan: null,
                noKantor: "",
                company_id: "",
                namaPejabat: "",
                jabatan: "",
                jabatanNasabah: "",
                no_ac_demo: "",
                tempat_ttd: "",
                complement: "",
                tanggalLahir: "",
                tempat_lahir: "",
                platform: [],
            },
        };
    },
    methods: {
        checkStatement(event) {
            if (this.currentPage == "/disclosure1") {
                this.form.disclosure_customer = event;
                this.disclosureValue = event;
                this.form.step = "disclosurCustomer";
            } else if (this.currentPage == "/disclosure2") {
                this.form.disclosure_risk = event;
                this.disclosureValue = event;
                this.form.step = "disclousureRisk";
            } else {
                this.form.disclosure_mandate = event;
                this.disclosureValue = event;
                this.form.step = "disclousureMandat";
            }
        },
        checkValidasiStatement() {
            let checkValid;
            let link;
            if (this.currentPage == "/disclosure1") {
                checkValid = this.form.disclosure_customer;
                link = "/register-datapribadi";
            } else if (this.currentPage == "/disclosure2") {
                checkValid = this.form.disclosure_risk;
                link = "/resiko";
            } else {
                checkValid = this.form.disclosure_mandate;
                link = "/amanat";
            }
            this.isLoading = true;
            if (checkValid) {
                axios
                    .put("/v2/kyc/customer/" + this.idCustomer, this.form)
                    .then((res) => {
                        let status = res.data.data.status_code;
                        if (status == "00") {
                            this.isLoading = false;
                            this.$router.push(link);
                        }
                    })
                    .catch((error) => {
                        this.isLoading = false;
                        console.log(error);
                        this.$notify({
                            group: "foo",
                            title: "Cek kembali inputan anda",
                            type: "error",
                            duration: 2000,
                        });
                    });
            } else {
                this.$toast.error("Statement Menerima belum disetujui");
                this.isLoading = false;
                // this.message = "Mohon untuk menyutujui pernyataan ya / tidak";
            }
        },
    },
    mounted() {
        this.currentPage = this.$route.path;
        axios.get("/v2/user/profile").then((res) => {
            this.dataPrint.platform = res.data.data.user.platform;
        });
        this.currentDate = new Date();
        this.$store.dispatch("getCustomer").then((res) => {
            this.form.has_set_investment_experience = res.has_set_investment_experience;
            this.form.has_set_trading_simulation = res.has_set_trading_simulation;
            this.form.has_confirm_costumer = res.has_confirm_costumer;
            this.form.has_set_company_profile = res.has_set_company_profile;
            this.form.has_set_mandate = res.has_set_mandate;
            this.form.has_set_risk = res.has_set_risk;
            this.form.has_set_trading_rules = res.has_set_trading_rules;
            this.form.completeness_verification = res.completeness_verification;
            this.form.disclosure_customer = res.disclosure_customer;
            this.form.disclosure_risk = res.disclosure_risk;
            this.form.disclosure_mandate = res.disclosure_mandate;
            if (this.currentPage == "/disclosure1") {
                this.form.step = "disclosurCustomer";
                this.disclosureValue = this.form.disclosure_customer;
            } else if (this.currentPage == "/disclosure2") {
                this.form.step = "disclousureRisk";
                this.disclosureValue = this.form.disclosure_risk;
            } else {
                this.form.step = "disclousureMandat";
                this.disclosureValue = this.form.disclosure_mandate;
            }
            this.idCustomer = res._id;
            let dataAddress = res.identity_address;
            this.identityAddress = dataAddress;
            this.dataPrint.fullname = res.fullname;
            this.dataPrint.ktp = res.ktp_no;
            this.dataPrint.telepone = res.phonenumber;
            this.dataPrint.tempat_ttd = res.identity_address.regency;
            this.dataPrint.tanggalLahir = res.date_of_birth;
            this.dataPrint.tempat_lahir = res.place_of_birth;
            this.dataPrint.alamat =
                dataAddress.address + ", Kel. " + dataAddress.village + ", Kec. " + dataAddress.district + " " + dataAddress.regency + " " + dataAddress.province;
        });
    },
};
</script>

<style scoped>
label {
    width: 12rem;
}

.container-outline {
    width: 70%;
}

.content-register {
    box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15);
    background: #ffffff;
    border-radius: 5px;
}

.button {
    display: flex;
    justify-content: space-between;
    padding: 76px 63px;
}

.register {
    margin: 46px 0;
}

.container {
    width: 100%;
}

.page {
    padding: 1cm;
    /* border: 5px red solid; */
    height: 257mm;
    /* outline: 2cm #FFFFFF solid; */
}

.format-text {
    text-transform: capitalize;
    display: flex;
    gap: 1rem;
}

.format-text span {
    width: 70%;
}

.footer-modal .btn-primer {
    margin: 0 auto;
}

.format-text::first-letter,
.format-text::first-line {
    text-transform: capitalize;
}

.wrap-document {
    /* width: 210mm; */
    min-height: 297mm;
    padding: 10mm;
    margin: 0 auto;
    /* border: 1px #D3D3D3 solid; */
    border-radius: 5px;
    background: white;
    /* box-shadow: 0 0 5px rgba(0, 0, 0, 0.1); */
    position: relative;
}

.tanda-tangan {
    width: 100%;
}

.top {
    display: flex;
    justify-content: space-between;
    font-size: 10px;
}

.header {
    display: flex;
    justify-content: space-between;
    font-size: 10px;
    margin-bottom: 25px;
}

.nomor {
    font-weight: bold;
}

.lampiran p {
    margin: 0;
    text-align: right;
}

.title {
    font-weight: bold;
    text-align: center;
    margin: 0 auto 40px;
    font-size: 14px;
}

.title-page {
    font-size: 25px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    margin: 0 0 50px;
}

.content {
    font-size: 14px;
}

.label-radio {
    width: 3rem;
    margin-left: 0.6rem;
}

.sub-content {
    font-weight: 700;
}

/* 
form {
  margin: 20px 0;
  text-align: right;
  font-weight: 700;
} */

.penutup {
    font-weight: normal;
    font-size: 14px;
    margin-bottom: 2rem;
}

.content-penutup {
    width: 80%;
    text-align: center;
    margin: 1rem auto;
}

.title-penutup {
    font-weight: bold;
    font-size: 16px;
    text-align: center;
}

.pernyataan {
    display: flex;
    padding: 0 1rem;
    margin-top: 1rem;
}

.pernyataan:last-child {
    margin-top: unset;
}

.label {
    width: 20rem;
}
.resiko {
    font-weight: 700;
}

.persetujuan {
    /* width: 60%; */
    font-size: 12px;
    display: flex;
    justify-content: flex-end;
}

.wrap-signature {
    text-align: center;
    width: 30%;
}

.footer {
    display: flex;
    font-size: 10px;
    justify-content: space-between;
    position: absolute;
    width: 80%;
    bottom: 0;
}

@page {
    size: A4;
    margin: 0;
}

@media (max-width: 768px) {
    .page {
        padding: 0;
    }

    .title {
        margin: 20px auto !important;
    }
    .container-outline {
        width: 90%;
    }

    li > span {
        display: none;
    }

    .form-input,
    select,
    .input-button {
        width: 100%;
    }

    .birtday,
    .kecamatan,
    .input-rt-rw {
        width: 100% !important;
        text-align: left;
    }

    .register {
        margin: 20px 0;
    }

    .title {
        font-size: 18px;
        margin: 0 0 20px;
    }

    .sub-title {
        margin-bottom: 20px;
    }

    .top-squence {
        width: 100%;
        padding: 15px 10px;
    }

    .container {
        width: 100%;
        padding: 25px 20px;
    }

    .identitas,
    .form-ktp-bagi,
    .tanggal-aktif,
    .tempat,
    .kecamatan,
    .input-rt-rw {
        margin: 0 0 10px;
    }

    .detail-alamat,
    .rt-rw {
        margin: 0 0 0.5rem;
    }

    .form-checkbox {
        align-items: flex-start;
    }

    .label--checkbox {
        position: inherit !important;
        margin-left: 15px;
    }

    label {
        display: block;
    }

    .button {
        display: block;
        width: 100%;
        padding: 25px 20px;
        text-align: center;
    }

    .btn-scondary,
    .btn-primer {
        width: 100%;
    }

    .btn-scondary {
        margin-bottom: 20px;
    }

    .content-modal {
        width: 95%;
    }

    .wrap-document {
        width: 100%;
        padding: 30px 0;
    }

    .group-file {
        display: block;
    }

    .wrap-label {
        width: 100%;
    }

    .picture {
        margin-bottom: 55px;
    }

    .video {
        height: 100%;
        object-fit: contain;
    }

    .feed {
        width: 80%;
        height: 100%;
        object-fit: cover;
        margin: auto;
    }
}
</style>
